import {
    FETCH_COUNTRIES_BEGIN,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_COUNTRIES_ERROR,
    FETCH_CITIES_BEGIN,
    FETCH_CITIES_SUCCESS,
    FETCH_CITIES_ERROR
} from '../actions/geoActions';

const defaultCountriesState = {
    countries: [],
    loading: false,
};

const defaultCitiesState = {
    cities: [],
    loading: false,
};

export const countriesList = (state = defaultCountriesState, action) => {
    switch (action.type) {
        case FETCH_COUNTRIES_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_COUNTRIES_SUCCESS:
            return {
                ...state,
                loading: false,
                countries: action.payload.countries,
            };
        default:
            return state;
    }
};

export const citiesList = (state = defaultCitiesState, action) => {
    switch (action.type) {
        case FETCH_CITIES_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_CITIES_SUCCESS:
            return {
                ...state,
                loading: false,
                cities: action.payload.cities,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/geo.js